import React from 'react'
import './directory.styles.scss'
import SECTIONS_DATA from './sections.data'
import { createStructuredSelector } from "reselect"; 
import { selectDirectorySections } from "../../redux/directory/directory.selectors";
import MenuItem from '../menu-item/menu-item.component'
import {connect} from 'react-redux'
import {Helmet} from 'react-helmet'

const Directory = () => {
    return(
            <div className="directory-menu">
                {/* <Helmet>
                <meta charset="utf-8"/>
                <meta name="viewport" content="width=device-width, initial-scale=1"/>
                <meta name="description" content="Disappointed with gadget search in Pakistan, visit our website as we bring best quality gadgets in pakistan for you and our gadget's price is unmatched"/>
                <title>Shop Best Gadgets in Pakistan | Acceronix</title>
                </Helmet> */}
                {
                    SECTIONS_DATA.map(({id, ...otherSectionProps}) =>(
                        <MenuItem key={id} {...otherSectionProps}/>
                    ))
                }
                 </div>
        );
            }
const MapStateToProps = createStructuredSelector({
    sections: selectDirectorySections
}) 
    

export default connect(MapStateToProps)(Directory);